import { FC, useMemo } from "react";
import FamilyMemberRow from "@components/Onboarding/OnboardingFamilyInfoForm/FamilyMemberRow";
import { FamilyMemberFormType } from "@utils/patientFormHelper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";
import StyledTableContainer from "@components/StyledTable";
import { Character } from "@models/character";

export interface FamilyMemberListProps {
  familyMembers: FamilyMemberFormType[];
  onEdit: (familyMember: FamilyMemberFormType) => void;
  onRemove: (index: number) => void;
  onSelect: (index: number) => void;
  selectedFamilyMembers: number[];
  characters: Character[];
}

const FamilyMemberList: FC<FamilyMemberListProps> = ({
  familyMembers,
  onEdit,
  onRemove,
  onSelect,
  selectedFamilyMembers,
  characters,
}) => {
  const { t } = useTranslation();
  const personIdCharacterMap = useMemo(() => {
    return characters.reduce((acc, character) => {
      if (character.person) {
        acc.set(character.person.id, character);
      }
      return acc;
    }, new Map<string, Character>());
  }, [characters]);

  return (
    <StyledTableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableContainer.StyledTableCell />
            <StyledTableContainer.StyledTableCell>
              {t("familyInfo.list.name")}
            </StyledTableContainer.StyledTableCell>
            <StyledTableContainer.StyledTableCell>
              {t("familyInfo.list.relation")}
            </StyledTableContainer.StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {familyMembers?.map((familyMember, index) => {
            if (familyMember.delete) {
              return "";
            }
            const character =
              familyMember.personId &&
              personIdCharacterMap.get(familyMember.personId);
            return (
              <FamilyMemberRow
                selected={selectedFamilyMembers.indexOf(index) > -1}
                onSelect={() => onSelect(index)}
                onEdit={() => onEdit(familyMember)}
                onRemove={() => onRemove(index)}
                familyMember={familyMember}
                key={familyMember._id}
                avatarUrl={character ? character.mainFace.faceUrl : undefined}
              />
            );
          })}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default FamilyMemberList;
